import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import PaymentPage from './pages/PaymentPage';
import OrderStatusPage from './pages/OrderStatusPage';
import HistoryPage from './pages/HistoryPage';
import { CartProvider } from './context/CartContext';
import TutorialPopup from './components/TutorialPopup';

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <CartProvider>
      <Router>
        <ScrollTop />
        <TutorialPopup />
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
          <Navbar />
          <div className="main-content" style={{ flex: 1 }}>
            <Routes>
              <Route path="/"                  element={<HomePage />} />
              <Route path="/cart"              element={<CartPage />} />
              <Route path="/checkout"          element={<CheckoutPage />} />
              <Route path="/payment/:orderId"  element={<PaymentPage />} />
              <Route path="/order/:orderId"    element={<OrderStatusPage />} />
              <Route path="/riwayat"           element={<HistoryPage />} />
            </Routes>
          </div>
          <footer style={{
            borderTop: '1px solid var(--border)',
            padding: '18px 28px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            color: 'var(--text3)',
            fontSize: '0.75rem',
            fontFamily: 'var(--mono)',
          }}>
            <span>// digital store — powered by QRIS</span>
            <span style={{ color: 'var(--primary)', opacity: 0.6 }}>⚡ PakAsir</span>
          </footer>
        </div>
      </Router>
    </CartProvider>
  );
}
